// src/components/ProtectedRoute.jsx
// Componente wrapper que protege rutas por autenticación y rol
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// Mapeo de rol → ruta de login correspondiente
const ROLE_LOGIN_ROUTES = {
  coach: '/entrenadores',
  club: '/clubes',
  judge: '/jueces',
  organizer: '/organizador',
  admin: '/admin/login',
};

const ProtectedRoute = ({ children, allowedRoles = [] }) => {
  const { isAuthenticated, role, loading, user } = useAuth();
  const location = useLocation();

  // Mientras carga la sesión o el perfil, mostrar loading
  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        background: '#fafafa',
        flexDirection: 'column',
        gap: '12px'
      }}>
        <div style={{
          width: '36px',
          height: '36px',
          border: '3px solid #e5e7eb',
          borderTopColor: '#18181b',
          borderRadius: '50%',
          animation: 'spin 0.8s linear infinite'
        }} />
        <p style={{ color: '#6b7280', fontSize: '14px' }}>Verificando sesión...</p>
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      </div>
    );
  }

  // No autenticado → redirigir al login
  if (!isAuthenticated) {
    // Intentar redirigir al login del rol que intentaba acceder
    const pathRole = Object.entries(ROLE_LOGIN_ROUTES).find(([, path]) =>
      location.pathname.startsWith(path)
    );
    const loginPath = pathRole ? pathRole[1] : '/';
    
    return <Navigate to={loginPath} state={{ from: location }} replace />;
  }

  // Determinar el rol actual: primero desde user.user_metadata, luego desde AuthContext
  const currentRole = user?.user_metadata?.role || role;

  // Autenticado pero sin el rol correcto
  if (allowedRoles.length > 0 && !allowedRoles.includes(currentRole)) {
    // Redirigir al home si no tiene el rol requerido
    return <Navigate to="/" replace />;
  }

  // Todo OK → renderizar children
  return children;
};

export default ProtectedRoute;
